<script>
export default {
  name: 'IconButton',
  props: {
    icon: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
    },
  },
};
</script>

<template>
  <div>
    <ElTooltip
      :content="tooltip"
      :disabled="!tooltip"
      placement="top"
      class="ui-icon-button"
    >
      <ElButton :icon="icon" :type="type" v-bind="$attrs" v-on="$listeners">
        <slot />
      </ElButton>
    </ElTooltip>
  </div>
</template>

<style>
.ui-icon-button {
  padding: 12px 13px;
}
</style>
